import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CtaStrip() {
  return (
    <section className="section-padding py-20 border-t border-ink-700 bg-ink-900/60" data-testid="cta-strip">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
        <h3 className="h-display text-3xl md:text-5xl max-w-[20ch]">
          Tell us what your lab or line needs.
        </h3>
        <Link to="/enquiry" className="btn-primary" data-testid="cta-strip-link">
          Send enquiry <ArrowUpRight size={14} />
        </Link>
      </div>
    </section>
  );
}
